import React from 'react'
import { Link } from 'react-router-dom'

function BlogGrid() {
  return (
    <div>
        <div className="section-bg section-padding subheader" style={{ backgroundImage: 'url(/tm/react/dronyug/assets/images/subheader.jpg)' }}>
    	<div className="container">
    		<div className="row">
    			<div className="col-12 text-center">
    				<h1 className="text-white page-title">Blog Grid</h1>
    			</div>
    		</div>
    	</div>
    </div>
    {/* <!-- Subheader End -->
    <!-- Blog Start --> */}
    <section className="section-padding section">
        <div className="container">
            <div className="row justify-content-center">
                <article className="col-lg-4 col-md-6">
                    <div className="post">
                        <div className="post_image">
                            <Link to="/blog-details" className="d-flex h-100">
                                <img src="/tm/react/dronyug/assets/images/blog/1.jpg" alt="img" className="image-fit"/>
                            </Link>
                        </div>
                        <div className="post_caption">
                            <div className="post_date">14 April 2024</div>
                            <h2 className="post_title"><Link to="/blog-details">Facing problem to get solution of your queries? Here is the solution</Link></h2>
                        </div>
                    </div>
                </article>
               
                <article className="col-lg-4 col-md-6">
                    <div className="post">
                        <div className="post_image">
                            <Link to="/blog-details" className="d-flex h-100">
                                <img src="/tm/react/dronyug/assets/images/blog/2.jpg" alt="img" className="image-fit"/>
                            </Link>
                        </div>
                        <div className="post_caption">
                            <div className="post_date">05 March 2024</div>
                            <h2 className="post_title"><Link to="/blog-details">Better solution to make your business more effective</Link></h2>
                        </div>
                    </div>
                </article>
                
                <article className="col-lg-4 col-md-6">
                    <div className="post">
                        <div className="post_image">
                            <Link to="/blog-details" className="d-flex h-100">
                                <img src="/tm/react/dronyug/assets/images/blog/3.jpg" alt="img" className="image-fit"/>
                            </Link>
                        </div>
                        <div className="post_caption">
                            <div className="post_date">25 Fab 2024</div>
                            <h2 className="post_title"><Link to="/blog-details">Platform where your problems meet with their solution</Link></h2>
                        </div>
                    </div>
                </article>
                
                <article className="col-lg-4 col-md-6">
                    <div className="post">
                        <div className="post_image">
                            <Link to="/blog-details" className="d-flex h-100">
                                <img src="/tm/react/dronyug/assets/images/blog/4.jpg" alt="img" className="image-fit"/>
                            </Link>
                        </div>
                        <div className="post_caption">
                            <div className="post_date">29 Jan 2024</div>
                            <h2 className="post_title"><Link to="/blog-details">Facing problem to get solution of your queries? Here is the solution</Link></h2>
                        </div>
                    </div>
                </article>
                
                <article className="col-lg-4 col-md-6">
                    <div className="post">
                        <div className="post_image">
                            <Link to="/blog-details" className="d-flex h-100">
                                <img src="/tm/react/dronyug/assets/images/blog/5.jpg" alt="img" className="image-fit"/>
                            </Link>
                        </div>
                        <div className="post_caption">
                            <div className="post_date">08 Fab 2024</div>
                            <h2 className="post_title"><Link to="/blog-details">Better solution to make your business more effective</Link></h2>
                        </div>
                    </div>
                </article>
               
                <article className="col-lg-4 col-md-6">
                    <div className="post">
                        <div className="post_image">
                            <Link to="/blog-details" className="d-flex h-100">
                                <img src="/tm/react/dronyug/assets/images/blog/6.jpg" alt="img" className="image-fit"/>
                            </Link>
                        </div>
                        <div className="post_caption">
                            <div className="post_date">21 March 2024</div>
                            <h2 className="post_title"><Link to="/blog-details">Platform where your problems meet with their solution</Link></h2>
                        </div>
                    </div>
                </article>
            </div>
            <div className="row">
                <div className="col-12">
                    <nav>
                        <ul className="pagination">
                            <li className="page-item">
                                <Link className="page-link" to="#" aria-label="Previous">
                                    <span aria-hidden="true">«</span>
                                    <span className="sr-only">Previous</span>
                                </Link>
                            </li>
                            <li className="page-item active"><Link className="page-link" to="#">1</Link></li>
                            <li className="page-item"><Link className="page-link" to="#">2</Link></li>
                            <li className="page-item"><Link className="page-link" to="#">3</Link></li>
                            <li className="page-item">
                                <Link className="page-link" to="#" aria-label="Next">
                                    <span aria-hidden="true">»</span>
                                    <span className="sr-only">Next</span>
                                </Link>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </div>
    </section>
    </div>
  )
}

export default BlogGrid